import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { NotFoundPage } from './NotFoundPage';
import { ServerErrorPage } from './ServerErrorPage';
import { ErrorStatusPage } from './ErrorStatusPage';

/**
 * Use as React Router `errorElement` for Arabic 404 / 500 handling.
 */
export function RouteErrorPage() {
    const error = useRouteError();
    const navigate = useNavigate();

    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            return <NotFoundPage />;
        }

        if (error.status === 401 || error.status === 403) {
            return (
                <ErrorStatusPage
                    code={error.status}
                    title="غير مصرح بالوصول"
                    description="ليس لديك صلاحية لعرض هذه الصفحة. يرجى تسجيل الدخول بحساب لديه الصلاحيات المناسبة."
                    homeLabel="العودة للرئيسية"
                />
            );
        }

        return (
            <ServerErrorPage
                message={
                    error.statusText ||
                    error.data?.message ||
                    `حدث خطأ في الخادم (رمز ${error.status}).`
                }
                onRetry={() => navigate(0)}
            />
        );
    }

    const message =
        error instanceof Error
            ? error.message
            : typeof error === 'string'
              ? error
              : 'حدث خطأ غير متوقع.';

    return <ServerErrorPage message={message} onRetry={() => navigate(0)} />;
}

export default RouteErrorPage;
